import { PowerUpType } from "../../data/enums";
import { PowerUpBase } from "./PowerUpBase";

export class SpeedBoostPowerUp extends PowerUpBase {
    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y, "powerup-speed", PowerUpType.SpeedBoost, 20000);
    }
}
